import moment from "moment";

export const LATEST_LEAD_STATUS_FILTER_OPTIONS = [
  { value: "follow-up", label: "Follow-up" },
  { value: "upcoming-revisit", label: "Upcoming Revisit" },
  { value: "revisit", label: "Revisit" },
  { value: "revisit-checked-in", label: "Revisit - checked in" },
  { value: "booking", label: "Booking" },
  { value: "registration", label: "Registration" },
  { value: "visit-cancel", label: "Visit Cancel" },
  { value: "not-interested", label: "Not interested" },
  { value: "reschedule", label: "Reschedule" },
];

const normalizeStatusLabel = (label) =>
  String(label || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export const matchesLatestLeadStatusFilter = (label, filterValue) => {
  if (!filterValue) return true;
  const n = normalizeStatusLabel(label);
  const filter = String(filterValue || "").trim();
  if (!n) return false;

  switch (filter) {
    case "follow-up":
      return (
        n.includes("follow") || n.includes("call") || n.includes("whatsapp")
      );
    case "upcoming-revisit":
      return n.includes("upcoming revisit") || n.includes("revisit scheduled");
    case "revisit-checked-in":
      return (
        n.includes("revisit") &&
        (n.includes("check") || n.includes("visited"))
      );
    case "revisit":
      return (
        n.includes("revisit") &&
        !n.includes("upcoming") &&
        !n.includes("check") &&
        !n.includes("scheduled")
      );
    case "booking":
      return n.includes("book") && !n.includes("cancel") && !n.includes("ready");
    case "registration":
      return n.includes("registr") && !n.includes("cancel");
    case "visit-cancel":
      return (
        (n.includes("cancel") &&
          !n.includes("book") &&
          !n.includes("registr")) ||
        n === "cancelled" ||
        n === "canceled" ||
        n === "cancellation"
      );
    case "not-interested":
      return n.includes("not interest") || n.includes("not fit");
    case "reschedule":
      return (
        n.includes("reschedule") ||
        n.includes("appointment rescheduled")
      );
    default:
      return n.includes(normalizeStatusLabel(filter));
  }
};

export const formatIstDateTime = (date) => {
  if (!date) return "N/A";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "N/A";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(parsed);
  const get = (type) => parts.find((part) => part.type === type)?.value || "";
  const dayPeriod = String(get("dayPeriod") || "").toUpperCase();
  return `${get("day")}/${get("month")}/${get("year")} · ${get("hour")}:${get("minute")} ${dayPeriod}`;
};

const LEGACY_BOOKING_DRIFT_MS = 4 * 60 * 60 * 1000;

/** Resolve booking instant; handles legacy offset-stored booking_date values. */
export const resolveBookingInstantForDisplay = (bookingDate, createdDate) => {
  const created = createdDate ? new Date(createdDate) : null;
  const booking = bookingDate ? new Date(bookingDate) : null;
  const createdMs =
    created && !Number.isNaN(created.getTime()) ? created.getTime() : NaN;
  const bookingMs =
    booking && !Number.isNaN(booking.getTime()) ? booking.getTime() : NaN;

  if (!Number.isNaN(createdMs)) {
    if (
      !Number.isNaN(bookingMs) &&
      bookingMs - createdMs > LEGACY_BOOKING_DRIFT_MS
    ) {
      return created;
    }
    if (!Number.isNaN(bookingMs)) return booking;
    return created;
  }

  if (!Number.isNaN(bookingMs)) return booking;
  return null;
};

/** IST booking datetime; backward-compatible with legacy stored values. */
export const formatBookingIstDateTime = (
  bookingDate,
  createdDate,
  { listing = false } = {},
) => {
  const created = createdDate ? new Date(createdDate) : null;
  const booking = bookingDate ? new Date(bookingDate) : null;
  const createdMs =
    created && !Number.isNaN(created.getTime()) ? created.getTime() : NaN;
  const bookingMs =
    booking && !Number.isNaN(booking.getTime()) ? booking.getTime() : NaN;

  if (!Number.isNaN(createdMs)) {
    const instant = resolveBookingInstantForDisplay(bookingDate, createdDate);
    if (!instant) return listing ? "-" : "N/A";
    return moment(instant).utcOffset(330).format(
      listing ? "DD-MM-YYYY hh:mm a" : "DD/MM/YYYY · h:mm A",
    );
  }

  if (!Number.isNaN(bookingMs)) {
    return moment.utc(bookingDate).format(
      listing ? "DD-MM-YYYY hh:mm a" : "DD/MM/YYYY · h:mm A",
    );
  }

  return listing ? "-" : "N/A";
};
